export function formatDeliveryTime(deliveryTime: number): string {
  const lang = localStorage.getItem('language');
  const isUz = lang === 'uz';

  if (isUz) {
    if (deliveryTime === 30) return 'Yarim soatda yetkazamiz';
    if (deliveryTime === 60) return '1 soatda yetkazamiz';
    if (deliveryTime < 60) return `${deliveryTime} daqiqada yetkazamiz`;

    const hours = Math.floor(deliveryTime / 60);
    const minutes = deliveryTime % 60;

    if (minutes === 0) {
      return `${hours} soatda yetkazamiz`;
    }

    return `${hours} soat ${minutes} daqiqada yetkazamiz`;
  }

  // Russian fallback
  if (deliveryTime === 30) return 'Доставим за полчаса';
  if (deliveryTime === 60) return 'Доставим за час';
  if (deliveryTime < 60) return `Доставим за ${deliveryTime} минут`;

  const hours = Math.floor(deliveryTime / 60);
  const minutes = deliveryTime % 60;

  if (minutes === 0) {
    return `Доставим за ${hours} час${hours > 1 ? 'а' : ''}`;
  }

  return `Доставим за ${hours} час${hours > 1 ? 'а' : ''} ${minutes} минут`;
}
